import { useQuery } from '@tanstack/react-query';
import { getFinanceSummary } from '../services/financeService';

export const useFinanceSummary = (month, year, calendar) => {
  return useQuery({
    queryKey: ['finance-summary', month, year, calendar],
    queryFn: () => getFinanceSummary(month, year, calendar).then(r => r.data),
    staleTime: 30000, // 30 seconds
    refetchOnWindowFocus: false,
  });
};
